import { isNullOrUndefined } from 'util';

export class StringHelper {
  public static Empty = '';

  public static isNullOrWhiteSpace(value: any): boolean {
    try {
      if (value === null || value === undefined || value === StringHelper.Empty) {
        return true;
      }

      return value.replace(/\s/g, '').length === 0;
    } catch (e) {
      return false;
    }
  }

  public static replace(value, valueReplace, valueNew): string {
    return value.replace(valueReplace, valueNew);
  }

  public static Format(value, ...args): string {
    try {
      return value.replace(/{(\d+(:.*)?)}/g, function(match, i) {
        const s = match.split(':');
        if (s.length > 1) {
          i = i[0];
          match = s[1].replace('}', '');
        }

        const arg = StringHelper.formatPattern(match, args[i]);
        return isNullOrUndefined(arg) ? StringHelper.Empty : arg;
      });
    } catch (e) {
      return StringHelper.Empty;
    }
  }

  private static formatPattern(match, arg): string {
    switch (match) {
      case 'L':
        arg = arg.toLowerCase();
        break;
      case 'U':
        arg = arg.toUpperCase();
        break;
      default:
        break;
    }

    return arg;
  }

  public static contains(value, compare): boolean {

    if (value.indexOf(compare) === -1) {
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/string-helper.ts